import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { MethodPayment } from '~/api/finance/financeApiTypes';
import { TextRegStyle } from '~/atomic/Typography';

interface MethodTemplateParams {
  Logo: ReactNode;
  Text: ReactNode;
  Bottom?: ReactNode;
  onCheck?: () => void;
}

export interface DefaultMethodPaymentParams {
  onCheck?: (method: MethodPayment) => void;
  isPayLoading?: boolean;
  isDisabled?: boolean;
}

export const MethodPaymentTemplate = ({
  Logo,
  Text,
  onCheck,
  isDisabled,
  isPayLoading,
  Bottom,
}: MethodTemplateParams & DefaultMethodPaymentParams) => {
  return (
    <SCMethodPaymentTemplateWrapper>
      <SCMethodPaymentTemplate
        data-is-disabled={isDisabled}
        data-is-pay-loading={isPayLoading}
        onClick={onCheck}
      >
        <SCIconWrapper>
          { Logo }
        </SCIconWrapper>
        <SCTextWrapper>
          { Text }
          { Bottom && Bottom }
        </SCTextWrapper>
      </SCMethodPaymentTemplate>
    </SCMethodPaymentTemplateWrapper>
  );
};

const SCMethodPaymentTemplateWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const SCTextWrapper = styled.div`
  ${TextRegStyle};
  color: var(--black-color);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 8px;
  width: 100%;
`;

const SCIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SCMethodPaymentTemplate = styled.div`
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  transition: box-shadow 0.3s ease;
  box-shadow: 0 1px 1px rgba(141, 147, 162, 0.25);
  cursor: pointer;

  &:hover {
    box-shadow: 0 3px 5px rgba(53, 63, 72, 0.25);
  }

  &[data-is-disabled="true"] {
    box-shadow: none;
    pointer-events: none;

    ${SCTextWrapper} {
      color: var(--gray3-color) !important; 

      > * {
        color: var(--gray3-color) !important; 
      }
    }

    ${SCIconWrapper} {
      > * {
        opacity: 0.5;
        filter: grayscale(0.4)
      }
    }
  }
  
  &[data-is-pay-loading="true"] {
    box-shadow: none;
    pointer-events: none;
    position: relative;

    ${SCTextWrapper} {
      color: var(--gray3-color) !important; 

      > * {
        color: var(--gray3-color) !important; 
      }
    }

    ${SCIconWrapper} {
      > * {
        opacity: 0.5;
        filter: grayscale(0.4)
      }
    }
    
    &:after {
      content: '';
      display: block;
      position: absolute;
      background-image: url('/image/eclipse-loader.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 50px;
      height: 50px;
      right: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(50%);
    }
  }
`;
